import { callEndedByDoctorManuallySubscription, personManuallyRemovedFromCallSub, callEndedByPatientManuallySubscription, activeProviderEndReasonSubscription, callOnHoldSubscription, callPausedForPatientSubscription, angularModalClosedSubscription, angularModalOpenedSubscription, doctorLeftSubscription, personAddedToGroupCallSubscription, sessionConnectedSubscription, sessionDisconnectedSubscription, screenSharingUpdatedSubscription, screenSharingStartedSubscription, screenPublisherErrorSubscription, } from '../subscriptions';
export var AngularServices;
(function (AngularServices) {
    AngularServices["COMMUNICATION_CONTROL"] = "communicationControl";
    AngularServices["GLOBAL_UI"] = "globalUi";
    AngularServices["TRACKING_FACTORY"] = "trackingFactory";
    AngularServices["ROOM_HELPERS_FACTORY"] = "roomHelpersFactory";
    AngularServices["RootScope"] = "$rootScope";
    AngularServices["VIDEO_PROVIDER_FACTORY"] = "VideoProviderFactory";
    AngularServices["PUBLISHER_MANAGER"] = "publisherManager";
    AngularServices["ModalsService"] = "modalsService";
})(AngularServices || (AngularServices = {}));
export var AngularMethods;
(function (AngularMethods) {
    AngularMethods["ADD_PERSON_TO_GROUP_CALL_BY_UID"] = "addPersonToGroupCallByUid";
    AngularMethods["UI"] = "ui";
    AngularMethods["GLOBAL_TRACKING"] = "globalTracking";
    AngularMethods["GET_ROOM"] = "getRoom";
    AngularMethods["GET_ROOM_URL"] = "getRoomUrl";
    AngularMethods["GET_ACTIVE_PROVIDER"] = "activeProvider";
    AngularMethods["B64_TO_BLOB"] = "b64toBlob";
})(AngularMethods || (AngularMethods = {}));
export var extensionIntegrEvents;
(function (extensionIntegrEvents) {
    extensionIntegrEvents["PERSON_MANUALLY_REMOVED_FROM_CALL"] = "PERSON_MANUALLY_REMOVED_FROM_CALL";
    extensionIntegrEvents["DOCTOR_ENDED_CALL"] = "DOCTOR_ENDED_CALL";
    extensionIntegrEvents["PATIENT_ENDED_CALL"] = "PATIENT_ENDED_CALL";
    extensionIntegrEvents["CALL_ON_HOLD"] = "CALL_ON_HOLD";
    extensionIntegrEvents["PAUSED"] = "PAUSED";
    extensionIntegrEvents["ANGULAR_MODAL_OPEN"] = "ANGULAR_MODAL_OPEN";
    extensionIntegrEvents["ANGULAR_MODAL_CLOSE"] = "ANGULAR_MODAL_CLOSE";
    extensionIntegrEvents["ACTIVE_PROVIDER_END_REASON"] = "activeProvider:endReason";
    extensionIntegrEvents["DOCTOR_LEFT"] = "DOCTOR_LEFT";
    extensionIntegrEvents["ADD_PERSON_TO_GROUP_CALL"] = "ADD_PERSON_TO_GROUP_CALL";
    extensionIntegrEvents["SESSION_CONNECTED"] = "activeProvider:sessionConnected";
    extensionIntegrEvents["SESSION_DISCONNECTED"] = "activeProvider:sessionDisconnected";
    extensionIntegrEvents["SCREEN_SHARING_UPDATED"] = "globalUi:screenSharingUpdated";
    extensionIntegrEvents["SCREEN_SHARING_STARTED"] = "activeProvider:otScreenShareStarted";
    extensionIntegrEvents["SCREEN_PUBLISHER_ERROR"] = "otScreenPublisher:error";
    extensionIntegrEvents["PAUSE_AND_START"] = "PAUSE_AND_START";
})(extensionIntegrEvents || (extensionIntegrEvents = {}));
export const angularServicesIntegration = new Map();
export const EVENT_HANDLERS_MAP = {
    [extensionIntegrEvents.PERSON_MANUALLY_REMOVED_FROM_CALL]: (event, person) => {
        personManuallyRemovedFromCallSub.execute(person.state);
    },
    [extensionIntegrEvents.DOCTOR_ENDED_CALL]: (event, person) => {
        callEndedByDoctorManuallySubscription.execute(person);
    },
    [extensionIntegrEvents.PATIENT_ENDED_CALL]: (event, person) => {
        callEndedByPatientManuallySubscription.execute(person);
    },
    [extensionIntegrEvents.DOCTOR_LEFT]: () => {
        doctorLeftSubscription.execute();
    },
    [extensionIntegrEvents.ACTIVE_PROVIDER_END_REASON]: (event, reason) => {
        activeProviderEndReasonSubscription.execute(reason);
    },
    [extensionIntegrEvents.CALL_ON_HOLD]: () => {
        callOnHoldSubscription.execute();
    },
    [extensionIntegrEvents.PAUSE_AND_START]: () => {
        callOnHoldSubscription.execute();
    },
    [extensionIntegrEvents.PAUSED]: () => {
        callPausedForPatientSubscription.execute();
    },
    [extensionIntegrEvents.ANGULAR_MODAL_OPEN]: () => {
        angularModalOpenedSubscription.execute();
    },
    [extensionIntegrEvents.ANGULAR_MODAL_CLOSE]: () => {
        angularModalClosedSubscription.execute();
    },
    [extensionIntegrEvents.ADD_PERSON_TO_GROUP_CALL]: (event, person) => {
        personAddedToGroupCallSubscription.execute(person);
    },
    [extensionIntegrEvents.SESSION_CONNECTED]: () => {
        sessionConnectedSubscription.execute();
    },
    [extensionIntegrEvents.SESSION_DISCONNECTED]: () => {
        sessionDisconnectedSubscription.execute();
    },
    [extensionIntegrEvents.SCREEN_SHARING_UPDATED]: (_event, isEnabled) => {
        screenSharingUpdatedSubscription.execute(isEnabled);
    },
    [extensionIntegrEvents.SCREEN_SHARING_STARTED]: () => {
        screenSharingStartedSubscription.execute();
    },
    [extensionIntegrEvents.SCREEN_PUBLISHER_ERROR]: (err) => {
        screenPublisherErrorSubscription.execute(err);
    },
};
